import { render } from "./EventAutoMessageSettingView.vue?vue&type=template&id=18fdc1af&scoped=true"
import script from "./EventAutoMessageSettingView.vue?vue&type=script&lang=js"
export * from "./EventAutoMessageSettingView.vue?vue&type=script&lang=js"

import "./EventAutoMessageSettingView.vue?vue&type=style&index=0&id=18fdc1af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fdc1af"]])

export default __exports__